import { render, staticRenderFns } from "./Attractions.vue?vue&type=template&id=28a848ae"
import script from "./Attractions.vue?vue&type=script&lang=js"
export * from "./Attractions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports